import z from 'zod';

const UserShortSchema = z.object({
  id: z.number(),
  email: z.string(),
  avatar: z.string().nullable(),
  firstName: z.string(),
  lastName: z.string(),
  roleId: z.number(),
  isActive: z.boolean(),
  isDeleted: z.boolean(),
  roleName: z.string(),
});

export const UserSchema = z.object({
  id: z.number(),
  email: z.string(),
  avatar: z.string().nullable(),
  firstName: z.string(),
  lastName: z.string(),
  role: z.string(),
  status: z.string(),
  isActive: z.boolean(),
  isDeleted: z.boolean(),
  mobileNumber: z.string(),
  officeNumber: z.string(),
  lastLogin: z.any().nullish(),
  // Because now the tags is empty on the users endpoint
  tags: z
    .array(
      z.object({
        category: z.string(),
        categoryType: z.string(),
        id: z.string(),
        level: z.number(),
        name: z.string(),
      }),
    )
    .default([]),
  isCurrent: z.boolean(),
  companyId: z.number(),
  workspaceId: z.number(),
  ffId: z.string(),
  emailSubscriptions: z.object({
    co2Email: z.boolean(),
  }),
  agencyUser: z.boolean(),
  assignedClients: z.array(z.number()),
});

export const UserShortListResponseSchema = z.array(UserShortSchema);
export const PaginatedUserListResponseSchema = z.object({
  results: z.array(UserSchema),
  count: z.number(),
});

export const AllUserListResponseSchema = z.array(UserSchema);
export type UserShortItem = z.infer<typeof UserShortSchema>;
export type UserItem = z.infer<typeof UserSchema>;

const UserLiteSchema = z.object({
  id: z.number(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
});

export const UserLiteListResponseSchema = z.object({
  data: z.object({
    items: z.array(UserLiteSchema),
  }),
  error: z.unknown().nullish(),
});

export type UserLiteItem = z.infer<typeof UserLiteSchema>;

const UserColumnOptionSchema = z.object({
  label: z.string(),
  value: z.union([z.string(), z.number()]),
});

const UserColumnSchema = z.object({
  id: z.string(),
  label: z.string(),
  type: z.string(),
  isHidden: z.boolean(),
  isMandatory: z.boolean(),
  options: z.array(UserColumnOptionSchema).nullable(),
});

export const UserColumnsResponseSchema = z.object({
  data: z.object({
    items: z.array(UserColumnSchema),
  }),
  error: z.unknown().nullish(),
});

export type UserColumn = z.infer<typeof UserColumnSchema>;

const LegacyUserSchema = z.object({
  id: z.number(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  mobileNumber: z.string().optional(),
  officeNumber: z.string().optional(),
  isTest: z.boolean().optional(),
  isActive: z.boolean().optional(),
  isCurrent: z.boolean().optional(),
  lastLogin: z.string().nullable().optional(),
  role: z.union([z.number(), z.string()]),
  isDeleted: z.boolean().optional(),
  avatar: z.string().nullable().optional(),
});

export const LegacyUserListResponseSchema = z.array(LegacyUserSchema);

export type LegacyUserItem = z.infer<typeof LegacyUserSchema>;
